import { render, staticRenderFns } from "./serve-citizen.vue?vue&type=template&id=031dbc66&scoped=true"
import script from "./serve-citizen.vue?vue&type=script&lang=ts"
export * from "./serve-citizen.vue?vue&type=script&lang=ts"
import style0 from "./serve-citizen.vue?vue&type=style&index=0&id=031dbc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031dbc66",
  null
  
)

export default component.exports